'use strict';
var detail = require('base/product/detail');
var base = require('./base');
var qtyInput = require('../components/quantityInput');
var clientValidation = require('../components/clientSideValidation');

base.carouselInit();
base.attributeSelect();
base.selectAttribute();
base.colorAttribute();
qtyInput.pdpInit();

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    $('.modal-body').spinner().start(false);
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        success: function (data) {
            $('body').append(data);
            $('#quickViewModal').modal('show');
            $('body').trigger('quickview:ready');
            clientValidation.invalid();
            clientValidation.clearErrorsOnChange();
            $.spinner().stop();
            qtyInput.qvInit();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

var exportDetail = $.extend({}, detail, {
    pdpEvents: function () {
        $(document).on('click', '.vote-btn', function (e) {
            e.preventDefault();
            var url = $('.yotpo-helpful').data('action');
            var button = $(this);
            var data;
            if (button.hasClass('active')) {
                data = {
                    review_id: $(this).data('id'),
                    vote_type: $(this).data('type'),
                    removeVote: true
                };
            } else {
                data = {
                    review_id: $(this).data('id'),
                    vote_type: $(this).data('type')
                };
            }

            var neighbourVote = button.siblings();
            if (neighbourVote.hasClass('active')) {
                var dataVal = {
                    review_id: button.data('id'),
                    vote_type: button.siblings('.active').data('type'),
                    removeVote: true
                };
                $.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    data: dataVal,
                    success: function () {
                        var neighbouringVoteBtn = button.siblings().find('.vote-count');
                        var neighbouringCount = parseFloat(neighbouringVoteBtn.text());
                        neighbouringCount -= 1;
                        neighbouringVoteBtn.text(neighbouringCount);
                        button.siblings().removeClass('active');
                    }
                });
            }

            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                data: data,
                success: function () {
                    var currentVote = button.find('.vote-count');
                    var count = parseFloat(currentVote.text());

                    if (button.hasClass('active')) {
                        button.removeClass('active');
                        count -= 1;
                        currentVote.text(count);
                    } else {
                        button.addClass('active');
                        count += 1;
                        currentVote.text(count);
                    }
                }
            });
        });

        $(document).on('click', '.paginated', function (e) {
            e.preventDefault();
            var url = $(this).data('url');
            var selected = $(this);
            var data = {
                page_no: $(this).data('page'),
                product_ID: $('.productId').val()
            };
            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'html',
                data: data,
                success: function (response) {
                    $('.review_updates').replaceWith(response);
                    $('html, body').animate({
                        scrollTop: $('.review_updates').offset().top - 130
                    }, 'slow');
                    $('.paging-section li').removeClass('selected');
                    selected.addClass('selected');
                    $('.yotpo-icon-left-arrow,.yotpo-icon-right-arrow').removeClass('pointer_none');
                    if ($('.paging-section li').first().hasClass('selected')) {
                        $('.yotpo-icon-left-arrow').addClass('pointer_none');
                    }
                    if ($('.paging-section li').last().hasClass('selected')) {
                        $('.yotpo-icon-right-arrow').addClass('pointer_none');
                    }
                }
            });
        });

        $(document).on('click', '.yotpo-icon-right-arrow', function (e) {
            e.preventDefault();
            var url = $('.paging-section li').data('url');
            var selectedVal = $('.paging-section li.selected').next();
            if (selectedVal.data('page') > 9) {
                var startNum = (selectedVal.data('page') - 9);
                var i = 0;
                $('.paging-section li').each(function () {
                    $(this).addClass('d-none');
                    if (i >= startNum && i < (startNum + 9)) {
                        $(this).removeClass('d-none');
                    }
                    i++;
                });
            }
            var data = {
                page_no: selectedVal.data('page'),
                product_ID: $('.productid span').text()
            };
            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'html',
                data: data,
                success: function (response) {
                    $('.review_updates').replaceWith(response);
                    $('html, body').animate({
                        scrollTop: $('.review_updates').offset().top - 130
                    }, 'slow');
                    $('.paging-section li').removeClass('selected');
                    var pageNo = $('.review_updates').data('page');
                    $("ul li.paginated[data-page='" + pageNo + "']").addClass('selected');
                    $('.yotpo-icon-right-arrow').removeClass('pointer_none');
                    if ($('.paging-section li').last().hasClass('selected')) {
                        $('.yotpo-icon-right-arrow').addClass('pointer_none');
                    }
                }
            });
        });

        $(document).on('click', '.yotpo-icon-left-arrow', function (e) {
            e.preventDefault();
            var url = $('.paging-section li').data('url');
            var i = 0;
            var startNum = 1;
            var selectedVal = $('.paging-section li.selected').prev();
            if (selectedVal.data('page') >= 9) {
                startNum = (selectedVal.data('page') - 8);
            }
            i = 1;
            $('.paging-section li').each(function () {
                $(this).addClass('d-none');
                if (i >= startNum && i <= (startNum + 8)) {
                    $(this).removeClass('d-none');
                }
                i++;
            });
            var data = {
                page_no: selectedVal.data('page'),
                product_ID: $('.productid span').text()
            };
            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'html',
                data: data,
                success: function (response) {
                    $('.review_updates').replaceWith(response);
                    $('html, body').animate({
                        scrollTop: $('.review_updates').offset().top - 120
                    }, 'slow');
                    $('.paging-section li').removeClass('selected');
                    var pageNo = $('.review_updates').data('page');
                    $("ul li.paginated[data-page='" + pageNo + "']").addClass('selected');
                    $('.yotpo-icon-left-arrow').removeClass('pointer_none');
                    if ($('.paging-section li').first().hasClass('selected')) {
                        $('.yotpo-icon-left-arrow').addClass('pointer_none');
                    }
                }
            });
        });

        $(document).on('click', '.write_review_btn', function () {
            if ($('.yotpo-main-widget').hasClass('show')) {
                $('.write-review-wrapper').toggle();
            }
            $('.yotpo-main-widget').addClass('show');

            $('html, body').animate({
                scrollTop: $('#yotpo-reviews-top-div').offset().top - 200
            }, 'slow');
        });

        $(document).on('click', '.stars-selectable', function () {
            $('html, body').animate({
                scrollTop: $('.yotpo-reviews-section').offset().top - 200
            }, 'slow');
        });

        $(document).on('click', '.noreviewslink', function () {
            $('html, body').animate({
                scrollTop: $('.yotpo-reviews-section').offset().top - 200
            }, 'slow');
        });

        $(document).on('click', '.video-container img', function () {
            $('html, body').animate({
                scrollTop: $('#videos').offset().top
            }, 'slow');
        });
    },
    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start(false);
        });
    },
    showQuickview: function () {
        $('body').on('click', '.quickview', function (e) {
            e.preventDefault();
            var selectedValueUrl = $(this).closest('a.quickview').attr('href');
            $(e.target).trigger('quickview:show');
            if ($('#quickViewModal').length !== 0) {
                $('#quickViewModal').remove();
            }
            fillModalElement(selectedValueUrl);
        });

        // On QV image click navigate to PDP
        $('body').on('click', '.quick-view-dialog .primary-images a', function (e) {
            e.preventDefault();
            $('.quickview .full-pdp-link').trigger('click');
        });

        $('.slide-link').trigger('zoom.destroy');
    },
    hideDialog: function () {
        $('body').on('product:afterAddToCart', function () {
            $('#quickViewModal').modal('hide');
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
            .attr('data-ready-to-order', response.product.readyToOrder)
            .data('ready-to-order', response.product.readyToOrder)
            .attr('data-available', response.product.available)
            .data('available', response.product.available);

            var availMessage = response.message;

            $('.availability-msg', response.$productContainer)
                .empty().html(availMessage);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) {
                        return $(item).data('available');
                    });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) {
                        return $(item).data('ready-to-order');
                    });

                $('.global-availability')
                    .attr('data-ready-to-order', allReady)
                    .data('ready-to-order', allReady)
                    .attr('data-available', allAvailable)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            var purchasable = response.product.readyToOrder && response.product.available;
            var incomplete = response.product.availability.incompletecombo;
            var invalidcombo = response.product.availability.invalidcombo;
            var notpurchasable = invalidcombo || (!purchasable && !incomplete);

            $('button.add-to-cart').removeClass('purchasable not-purchasable incomplete invalidcombo');

            if (notpurchasable) {
                $('button.add-to-cart').addClass('not-purchasable');
            }
            if (purchasable) {
                $('button.add-to-cart').addClass('purchasable');
            }
            if (incomplete) {
                $('button.add-to-cart').addClass('incomplete');
            }
            if (invalidcombo) {
                $('button.add-to-cart').addClass('invalidcombo');
            }
            if (purchasable || (incomplete && !invalidcombo)) {
                $('button.add-to-cart').removeAttr('disabled');
            } else { // invalidcombo || notpurchasable || anything else
                $('button.add-to-cart').attr('disabled', 'disabled');
            }

            // update global add to cart (single products, bundles)
            var enableGlobal = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            detail.methods.updateAddToCartEnableDisableOtherElements(!enableGlobal);
            if (response.product.availability.invalidcombo) {
                $('button.add-to-cart').text(response.resources.label_invalidcombo);
            } else if (response.product.availability.outofstock) {
                $('button.add-to-cart').text(response.resources.outofstock);
            } else {
                $('button.add-to-cart').text(response.resources.addtocart);
            }
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                // update product bundle items
                response.container.attr('data-pid', response.data.product.id).data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                // update set items; update data attr and DOM attr
                response.container.attr('data-pid', response.data.product.id).data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
                // update ATC button data-pid value
                response.container.find('.btn.add-to-cart').attr('data-pid', response.data.product.id).data('pid', response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(.bundle-item)').attr('data-pid', response.data.product.id).data('pid', response.data.product.id);
            }

            if (response.data.product.variationAttributes) {
                response.data.product.variationAttributes.forEach(function (attr) {
                    var $attrContainer = response.container.find('[data-attr="' + attr.id + '"] .attribute');
                    var $selectedAttrLabel = $attrContainer.find('.selected-attribute-label');

                    if (!$selectedAttrLabel.length) {
                        $selectedAttrLabel = $attrContainer.closest('.card').find('.selected-attribute-label');
                    }

                    if (attr.displayValue) {
                        const selectionText = attr.displayValue;
                        $selectedAttrLabel.text(selectionText);
                        $selectedAttrLabel.closest('.row-label').addClass('selected');
                        $selectedAttrLabel.closest('.attribute').addClass('selected').removeClass('selection-error');
                    } else {
                        $selectedAttrLabel.text($selectedAttrLabel.data('no-selection-msg'));
                        $selectedAttrLabel.closest('.row-label').removeClass('selected');
                        $selectedAttrLabel.closest('.attribute').removeClass('selected');
                    }
                });
            }
        });
    },
    disableImageClick: function () {
        $('body').on('click', '.primary-images a', function (e) {
            e.preventDefault();
        });
    },
    addToCart: base.addToCart
});

module.exports = exportDetail;
